// extracted by mini-css-extract-plugin
export default {"root":"style_root__B92at","checked":"style_checked__bS1v+"};